
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic07Static as ObiHydraulic07StaticElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-07-static.js';
 
 
 

 
 export const ObiHydraulic07Static = createComponent({
   react: React,
   tagName: 'obi-hydraulic-07-static',
   elementClass: ObiHydraulic07StaticElement,
   events: {
     
   }
  });
 
 